import { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './type-layout.module.scss';

interface TypeLayoutProps {
  children?: ReactNode;
  className?: string;
  [key: string]: unknown;
}

export const TypeLayout = ({
  children,
  className,
  ...rest
}: TypeLayoutProps) => (
  <div className={classNames(styles.layout, className)} {...rest}>
    {children}
  </div>
);

export const TypeLayoutBody = ({
  children,
  className,
  ...rest
}: TypeLayoutProps) => (
  <div className={classNames(styles.body, className)} {...rest}>
    {children}
  </div>
);

export const TypeLayoutRow = ({
  children,
  className,
  ...rest
}: TypeLayoutProps) => (
  <div className={classNames(styles.row, className)} {...rest}>
    {children}
  </div>
);

export const TypeLayoutCell = ({
  children,
  className,
  ...rest
}: TypeLayoutProps) => (
  <div className={classNames(styles.cell, className)} {...rest}>
    {children}
  </div>
);
